(function ($) {
  'use strict';

  const SELECTOR = '.usp-item__track';
  const MOBILE_QUERY = '(max-width: 550px)';

  const OPTIONS = {
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    prevArrow:
      '<button type="button" class="usp-item__nav usp-item__nav--prev" aria-label="Vorige"></button>',
    nextArrow:
      '<button type="button" class="usp-item__nav usp-item__nav--next" aria-label="Volgende"></button>',
    responsive: [
      {
        breakpoint: 420,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  function syncSliders(mql) {
    if (typeof $.fn.slick !== 'function') {
      return;
    }

    $(SELECTOR).each(function () {
      const $track = $(this);
      const isSlick = $track.hasClass('slick-initialized');

      if (mql.matches && !isSlick) {
        $track.slick($.extend({}, OPTIONS, { appendArrows: $track.parent() }));
      } else if (!mql.matches && isSlick) {
        $track.slick('unslick');
      }
    });
  }

  $(function () {
    if (!$(SELECTOR).length) {
      return;
    }

    const mql = window.matchMedia(MOBILE_QUERY);

    syncSliders(mql);

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', syncSliders);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(syncSliders);
    }
  });
})(jQuery);
